import { memo, useCallback } from 'react';
import { twMerge } from 'tailwind-merge';
import cn from 'classnames';
import { TSuggestItem } from 'src/services/SearchService';
import { Element } from 'src/components';
import SearchItem from './SearchItem';
interface IProps {
    keyword: string;
    suggest: (TSuggestItem & { isTopic: boolean })[];
    resetSuggest: () => void;
    show?: boolean;
}

const SearchDropdown = ({ suggest = [], resetSuggest, show }: IProps) => {
    const renderItems = useCallback(() => {
        return suggest.map((item, index) => (
            <SearchItem
                index={index}
                key={item.id}
                onClick={resetSuggest}
                {...item}
            />
        ));
    }, [suggest]);

    if (!suggest.length) return null;

    return (
        <Element
            className={twMerge(
                'bm-search-dropdown',
                'absolute z-[20] top-[calc(100%+5px)] left-[-1px]',
                'w-full',
                'text-[var(--dark)] text-[1.8rem]',
                'bg-white',
                'hidden',
                'border border-solid border-[rgba(0,0,0,0.1)]',
                'shadow-[0_3px_8px_rgb(0_0_0_/_5%)]',
                cn({
                    ['block']: show,
                })
            )}
        >
            <Element renderAs="ul">{renderItems()}</Element>
        </Element>
    );
};

export default memo(SearchDropdown);
